const UserType = {
    Admin: 'Admin',
    Student: 'Student',
    Professor: 'Professor'
};

export { UserType };
